<template>
  <div class="article">
    <h1>Coolpad CUI for Desktop</h1>
    <i>酷派桌面端 Web UI 桌面端组件库</i>
      <p>所属公司：Coolpad 酷派</p>
      <p>负责环节：</p>
      <ol>
        <li>UI Design</li>
        <li>CSS Coding</li>
      </ol>
      <p>设计成员：1</p>
      <p>
        项目描述：为 Coolpad 桌面 Web 线上商场而定制的一套 UI 组件库
      </p>
    <h2>生产工具</h2>
    <ul>
      <li>Sketch</li>
      <li>Sublime Text</li>
    </ul>
    <br />
    <VLazyImage :src="require(`@/assets/sketch.png`)" :src-placeholder="require(`@/assets/loading.jpg`)" alt=""/>
    <VLazyImage :src="require(`@/assets/sublime.png`)" :src-placeholder="require(`@/assets/loading.jpg`)" alt=""/>
    <h2>输出内容</h2>
    <ol>
      <li>GUI 设计文档</li>
      <li>HTML + CSS 静态组件样式</li>
    </ol>
    <h2>组件库预览</h2>
    <a href="https://cui-pc.vicless.com/" target="_blank">点击预览 https://cui-pc.vicless.com/</a>
    <viewer class="img">
      <VLazyImage :src="require(`@/assets/coolpad_pc_ui/1.jpg`)" :src-placeholder="require(`@/assets/loading.jpg`)" alt=""/>
    </viewer>

  </div>
</template>

<script>
import VLazyImage from "v-lazy-image"
export default {
  name: "Library",
  components: {
    VLazyImage
  },
};
</script>